import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import QRCode from 'react-qr-code';
import { fontsize24, poppins300, poppins600 } from 'theme/common.style';
import { Box } from '@mui/material';
import Loading from 'assets/images/loading.png';

export default function QrCodeGenerator({
  openGen,
  setOpenGen,
  value,
  userAppId,
}) {
  return (
    <div>
      <Dialog
        open={openGen}
        onClose={() => setOpenGen(false)}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth
        maxWidth={'xs'}
      >
        <DialogTitle
          sx={{ ...poppins600, fontSize: fontsize24, color: 'primary' }}
          textAlign={'center'}
          id="scroll-dialog-title"
        >
          {`User ID: ${userAppId}`}
        </DialogTitle>

        <DialogContent
          dividers={false}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Box sx={{ position: 'relative', width: 250, height: 250 }}>
            <QRCode
              size={128}
              style={{
                height: '250px',
                maxWidth: '100%',
                width: '250px',
              }}
              value={value}
              viewBox={`0 0 128 128`}
            />

            <Box
              component="img"
              src={Loading}
              alt="logo"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 40,
                height: 40,
                backgroundColor: '#fff',
                borderRadius: '4px',
                padding: '4px',
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Button
            sx={{
              fontFamily: 'Poppins !important',
              fontStyle: 'normal !important',
              fontWeight: '400 !important',
              fontSize: '14px !important',
              color: 'white',
              padding: '10px 39px',
              textDecoration: 'none',
              textTransform: 'none',
              background: '#4CA4FF',
              ':hover': {
                backgroundColor: '#4CA4FF',
                color: 'white',
              },
            }}
            variant="contained"
            onClick={() => setOpenGen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
